<template>
  <q-form ref="editForm">
    <c-card title="화기작업 상세정보" class="cardClassDetailForm no-margin">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <c-text
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            label="작업개요"
            name="workSummary"
            v-model="workPermit.workSummary"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-process
            :disabled="!isWriting"
            :editable="editable"
            label="단위공정"
            name="processCd"
            v-model="workPermit.processCd"
          >
          </c-process>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :editable="editable"
            :disabled="!isWriting"
            label="작업명"
            name="sopName"
            v-model="workPermit.sopName"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-vendor
            :disabled="!isWriting"
            :editable="editable"
            :isWrite="true"
            :data="workPermit"
            label="작업업체"
            name="vendorCd"
            v-model="workPermit.vendorCd"
            @dataChange="vendorChange"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-location
            isMapShowing
            :disabled="!isWriting"
            :editable="editable"
            :data="workPermit"
            etcFlag="Y"
            etcInput="locationEtc"
            label="작업장소"
            name="workLocation"
            v-model="workPermit.workLocation"
            @dataChange="setLocationInfo"
          >
          </c-location>
        </div>
        <div
          v-if="!isVendorReqeust"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
        >
          <c-equip
            :disabled="!isWriting"
            :editable="editable"
            :plantCd="workPermit.plantCd"
            :processCd="workPermit.processCd"
            :data="workPermit"
            :isWrite="true"
            label="관련 설비"
            name="equipmentCd"
            v-model="workPermit.equipmentCd"
          >
          </c-equip>
        </div>
        <div
          v-if="!isVendorReqeust"
          class="col-xs-6 col-sm-4 col-md-2 col-lg-2"
        >
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            :isFlag="true"
            label="PSM 관련 여부"
            name="psmFlag"
            v-model="workPermit.psmFlag"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            label="신청인"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-field
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            :data="workPermit"
            :plantCd="workPermit.plantCd"
            deptValue="workManagerDeptCd"
            type="dept_user"
            userType="lnf"
            label="LBLMANAGER"
            beforeText=""
            name="workManagerId"
            v-model="workPermit.workManagerId"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="!isWriting"
            :editable="editable"
            type="number"
            label="작업자 인원수"
            name="workerCnt"
            v-model="workPermit.workerCnt"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_PROTECTIVE_GEAR_CD"
            :isObject="true"
            valueText="sopProtectiveGearName"
            valueKey="sopProtectiveGearCd"
            label="보호구"
            name="protectiveGears"
            v-model="workPermit.protectiveGears"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            :rows="2"
            label="기타요구사항"
            name="specialRequirements"
            v-model="workPermit.specialRequirements"
          >
          </c-textarea>
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <!-- class="q-mt-md" -->
        <c-table
          title="안전조치 요구사항"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="workPermit.checkResults"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable && isWriting"
          :contentsField="contentsField"
        >
          <!-- @table-data-change="tableDataChange" -->
        </c-table>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <c-card title="발급 정보" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="issuedDeptCd"
                    type="dept_user"
                    label="발급"
                    beforeText=""
                    name="issuedUserId"
                    v-model="workPermit.issuedUserId"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="approvalDeptCd"
                    type="dept_user"
                    label="승인 (생산지원팀장)"
                    beforeText=""
                    name="approvalUserId"
                    v-model="workPermit.approvalUserId"
                  />
                  <div v-if="workPermit.approvalUserId2" class="text-grey-8 trans">이양자 : 
                    {{ getUserInfo(workPermit.approvalUserId2, 2)+' / '+getUserInfo(workPermit.approvalUserId2, 1) }}
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :required="confiFlag"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptDrivingManagerDeptCd"
                    type="dept_user"
                    label="운전부서장"
                    name="maintenanceDeptDrivingManagerId"
                    v-model="workPermit.maintenanceDeptDrivingManagerId"
                  />
                  <div v-if="workPermit.maintenanceDeptDrivingManagerId2" class="text-grey-8 trans">이양자 : 
                    {{ getUserInfo(workPermit.maintenanceDeptDrivingManagerId2, 2)+' / '+getUserInfo(workPermit.maintenanceDeptDrivingManagerId2, 1) }}
                  </div>
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <c-card
              title="안전조치확인 정보"
              class="cardClassDetailForm no-margin"
            >
              <template slot="card-detail">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptCheckDeptCd"
                    type="dept_user"
                    label="책임자"
                    name="maintenanceDeptCheckUserId"
                    v-model="workPermit.maintenanceDeptCheckUserId"
                  />
                  <div v-if="workPermit.maintenanceDeptCheckUserId2" class="text-grey-8 trans">이양자 : 
                    {{ getUserInfo(workPermit.maintenanceDeptCheckUserId2, 2)+' / '+getUserInfo(workPermit.maintenanceDeptCheckUserId2, 1) }}
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptEntryDeptCd"
                    type="dept_user"
                    label="담당자"
                    name="maintenanceDeptEntryUserId"
                    v-model="workPermit.maintenanceDeptEntryUserId"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptSafetyMnagerDeptCd"
                    type="dept_user"
                    label="안전관리자"
                    name="maintenanceDeptSafetyManagerId"
                    v-model="workPermit.maintenanceDeptSafetyManagerId"
                  />
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <!-- class="q-mt-md" -->
            <c-table
              ref="gasTable"
              title="가스농도 측정"
              :columns="grid2.columns"
              :gridHeight="grid2.height"
              :data="workPermit.gases"
              :filtering="false"
              :columnSetting="false"
              :usePaging="false"
              :editable="editable && isWriting"
              selection="multiple"
              rowKey="sopGasCheckId"
            >
              <!-- <template slot="customTableTitleEditor">
                <q-card class="custom-card no-margin" flat bordered>
                  <q-card-section horizontal class="cardhead bg-grey-3">
                    <q-card-section class="q-pa-xs">
                      <div class="gas-card-title text-grey-8" style="display:inline;">가스점검</div>
                      <div class="text-caption text-grey q-pl-xs" style="display:inline;">
                        가스농도 측정에 필요한 기기와 점검/확인자를 지정하세요.
                      </div>
                    </q-card-section>
                  </q-card-section>

                  <q-separator />

                  <q-card-actions>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="점검기기명"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="점검자"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="확인자(입회자)"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                  </q-card-actions>
                </q-card>
              </template> -->
              <template slot="table-button">
                <q-btn-group outline>
                  <!-- 추가 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000253"
                    icon="add"
                    :showLoading="false"
                    @btnClicked="addGas"
                  />
                  <!-- 제외 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000275"
                    icon="remove"
                    :showLoading="false"
                    @btnClicked="removeGas"
                  />
                </q-btn-group>
              </template>
            </c-table>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from "quasar";
import eventBus from "@/js/eventBus";
import selectConfig from "@/js/selectConfig";
export default {
  name: "swp-fire",
  props: {
    workPermit: {
      type: Object,
      default: function () {
        return {
          sopWorkPermitId: "", // 작업허가서 일련번호
          plantCd: "", // 사업장 코드
          sopName: "", // 작업명
          mdmSopId: "", // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: "", // 허가번호_(YYYYMMDD-01)
          swpStepCd: "", // 진행단계 코드
          applicationDeptCd: "", // 신청인 부서코드
          applicationDeptName: "",
          applicationUserId: "", // 신청인 ID
          applicationUserName: "",
          permitTypeCd: "", // 허가서 구분_화기/일반
          permitDate: "", // 허가일
          workStartTime: "", // 작업시작시간
          workEndTime: "", // 작업종료시간
          workTime: [], // 작업시간
          processCd: "", // 작업공정
          workLocation: "", // 작업장소
          locationEtc: "", // 기타장소
          locationMarkFlag: "Y", // 위치 직접 표시 여부
          equipmentCd: "", // 설비번호_설비마스터
          workSummary: "", // 작업개요
          specialRequirements: "", // 특별요구사항
          maintenanceDeptCheckUserId: "", // 정비부서 책임자 - 안전조치확인
          maintenanceDeptCheckUserId2: null, // 이양자
          maintenanceDeptEntryUserId: "", // 정비부서 입회자 - 안전조치확인
          maintenanceDeptSafetyManagerId: "", // 정비부서 안전관리자 - 안전조치확인
          maintenanceDeptDrivingManagerId: "", // 정비부서 운전부서장 - 안전조치확인
          maintenanceDeptDrivingManagerId2: null, // 이양자
          workCompleteTime: "", // 작업완료시간
          workCompleteEntryUserId: "", // 작업완료 입회자/확인자
          workCompleteWorkUserId: "", // 작업완료 작업자
          issuedDeptCd: "", // 발급자 부서코드
          issuedUserId: "", // 발급자 ID
          approvalDeptCd: "", // 승인자 부서코드
          approvalUserId: "", // 승인자 ID
          approvalUserId2: null, // 승인이양자 ID
          relationCooperation1DeptCd: "", // 관련부서 협조자1 부서코드
          relationCooperation1UserId: "", // 관련부서 협조자1 ID
          relationCooperation2DeptCd: "", // 관련부서 협조자2 부서코드
          relationCooperation2UserId: "", // 관련부서 협조자2 ID
          vendorCd: "", // 작업업체 코드
          vendorName: "", // 작업업체 코드
          overWorkFlag: "", // 연장작업 여부
          vendorFlag: 0, // 업체작성여부
          psmFlag: "N", // PSM 관련 여부
          assessWriteUserId: "", // 작업위험성평가_작성자 ID
          assessApprovalUserId: "", // 작업위험성평가_승인자 ID
          sopConstructionId: "",
          workerCnt: null,
          regUserId: "", // 등록자 ID
          chgUserId: "", // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          deleteCheckResults: [],
          gases: [],
          gasChecks: [], // 저장용
          gasCheckVals: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
          locationInfos: [],
        };
      },
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    confiFlag: {
      type: Boolean,
      default: false,
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
    saveCall: {
      type: Object,
      default: function () {
        return {
          saveCallData: "",
        };
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: "580px",
      },
      grid2: {
        columns: [],
        height: "382px",
      },
      useGasItems: [],
      editable: true,
      listCheckItemUrl: "",
      listGasItemUrl: "",
      listSopUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "90%",
        top: "10px",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    request() {
      return this.isVendorReqeust
        ? this.workPermit.applicationDeptName
        : this.workPermit.applicationDeptName +
            " / " +
            this.workPermit.applicationUserName;
    },
    isVendorReqeust() {
      return this.workPermit.vendorFlag > 0;
    },
  },
  watch: {
    "workPermit.plantCd"() {
      this.$set(this.workPermit, "checkResults", []);
      this.$set(this.workPermit, "gases", []);
      this.getCheckItemList();
      this.getGasItemList();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    eventBus.$on("vaildForm", (type) => {
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].validate().then((_result) => {
          this.$emit("validResult", _result, type);
        });
      }
    });
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listCheckItemUrl = selectConfig.sop.swp.workChekItem.list.url;
      this.listGasItemUrl = selectConfig.sop.swp.gas.list.url;
      this.listSopUrl = selectConfig.mdm.sop.jobhazard.url;
      // code setting
      // list setting
      this.getCheckItemList();
      this.getGasItemList();
    },
    getCheckItemList() {
      /**
       * default 값을 조회
       *
       * 초기인 경우 workPermit.checkResults에 값을 그대로 적용
       * 작성중 단계인 경우 default 값에 새로운 항목이 있을시에 workPermit.checkResults에 추가하여 입력을 받을 수 있도록 조치
       * 승인완료, 연장, 취소, 작업완료인 경우 저장된 데이터를 그대로 표시하며 이 경우 default값을 조회하지 않도록 조치
       */
      this.grid.columns = [
        // 항목
        {
          name: "checkItemName",
          field: "checkItemName",
          label: "LBL0000233",
          align: "left",
          sortable: true,
        },
        // 필요
        {
          name: "necessaryFlag",
          field: "necessaryFlag",
          label: "LBL0000234",
          align: "center",
          sortable: false,
          type: "check",
          true: "Y",
          false: "N",
          value: "N",
          setHeader: true,
        },
        // 확인
        // {
        //   name: 'confirmFlag',
        //   field: 'confirmFlag',
        //   label: 'LBL0000235',
        //   align: 'center',
        //   sortable: false,
        //   type: 'check',
        //   disableTarget: 'necessaryFlag',
        //   disableCon: 'Y',
        //   'true': 'Y',
        //   'false': 'N',
        //   value: 'N',
        //   setHeader: true,
        // },
      ];
      if (!this.workPermit.plantCd) return;
      if (!this.workPermit.checkResults) this.workPermit.checkResults = [];
      if (!this.isOld || this.workPermit.swpStepCd === "SS00000001") {
        this.$http.url = this.listCheckItemUrl;
        this.$http.type = "GET";
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
          sopWorkTypeCd: "SWT0000005",
          useFlag: "Y",
        };
        this.$http.request((_result) => {
          if (
            !this.isOld &&
            (!this.workPermit.checkResults ||
              this.workPermit.checkResults.length === 0)
          ) {
            // 최초인 경우 조치항목을 가지고 있지 않음으로 해당 값을 표시
            this.$_.forEach(_result.data, (item) => {
              this.workPermit.checkResults.push({
                sopWorkPermitId: "", // 작업허가서 일련번호
                supplementWorkTypeCd: "", // 보충작업구분
                sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                checkItemName: item.checkItemName, // 점검항목명
                sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                necessaryFlag: "Y", // 필요
                // confirmFlag: 'N',  // 확인
                confirmUserId: "", // 확인자
                confirmUserName: "", // 확인자명
                regUserId: this.$store.getters.user.userId, // 등록자 ID
                chgUserId: "", // 수정자 ID
                editFlag: "C",
              });
            });
          } else {
            this.$_.forEach(_result.data, (item) => {
              if (
                this.$_.findIndex(this.workPermit.checkResults, {
                  sopCheckItemId: item.sopCheckItemId,
                }) === -1
              ) {
                this.workPermit.checkResults.push({
                  sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
                  supplementWorkTypeCd: "", // 보충작업구분
                  sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                  checkItemName: item.checkItemName, // 점검항목명
                  sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                  necessaryFlag: "Y", // 필요
                  // confirmFlag: 'N',  // 확인
                  confirmUserId: "", // 확인자
                  confirmUserName: "", // 확인자명
                  regUserId: this.$store.getters.user.userId, // 등록자 ID
                  chgUserId: "", // 수정자 ID
                  editFlag: "C",
                });
              }
            });
          }

          // 확인자
          if (
            this.$_.findIndex(_result.data, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1 ||
            this.$_.findIndex(this.workPermit.checkResults, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1
          ) {
            this.grid.columns.push({
              name: "confirmUserName",
              field: "confirmUserName",
              label: "LBL0000240",
              align: "center",
              sortable: true,
              type: "user",
              userId: "confirmUserId",
              disableTarget: "necessaryFlag",
              disableCon: "Y",
            });
          }
        });
        // 확인자
      } else {
        if (
          this.$_.findIndex(this.workPermit.checkResults, {
            sopCheckItemKindCd: "SCIK000005",
          }) > -1
        ) {
          this.grid.columns.push({
            name: "confirmUserName",
            field: "confirmUserName",
            label: "LBL0000240",
            align: "center",
            sortable: true,
            type: "user",
            userId: "confirmUserId",
            disableTarget: "necessaryFlag",
            disableCon: "Y",
          });
        }
      }
    },
    getGasItemList() {
      let columns = [
        // 점검시간
        {
          name: "checkTime",
          field: "checkTime",
          label: "LBL0000237",
          align: "center",
          type: "datetime",
          minuteStep: 10,
          sortable: false,
          style: "width:15%",
        },
        // 점검기기
        {
          name: "gasCheckMachine",
          field: "gasCheckMachine",
          label: "LBL0000238",
          align: "center",
          sortable: false,
          type: "text",
          value: "",
          setHeader: true,
          style: "width:15%",
        },
        // 점검자
        {
          name: "gasCheckUserName",
          field: "gasCheckUserName",
          label: "LBL0000239",
          align: "center",
          sortable: false,
          type: "user",
          userId: "gasCheckUserId",
          value: "",
          setHeader: true,
          style: "width:10%",
        },
        // 확인자
        {
          name: "gasConfirmUserName",
          field: "gasConfirmUserName",
          label: "LBL0000240",
          align: "center",
          sortable: false,
          type: "user",
          userId: "gasConfirmUserId",
          value: "",
          setHeader: true,
          style: "width:10%",
        },
      ];

      this.$http.url = this.listGasItemUrl;
      this.$http.type = "GET";
      this.$http.param = {
        plantCd: this.workPermit.plantCd,
        // sopWorkTypeCd: 'SWT0000005',
      };
      this.$http.request((_result) => {
        this.useGasItems = [];
        if (this.workPermit.gases && this.workPermit.gases.length > 0) {
          let pushData = [];
          this.$_.forEach(this.workPermit.gases, (gas) => {
            for (let gasValue in gas) {
              let idx = this.$_.findIndex(_result.data, { sopGasId: gasValue });
              let idx2 = this.$_.findIndex(pushData, { sopGasId: gasValue });
              /**
               * idx의 경우 기본적으로 존재하는지 여부를 판단하지만
               *            예전 입력된 값 중 useFlag N처리된 값이 있는 경우는 허용
               */
              if (idx > -1 && gas[gasValue] !== "-" && idx2 === -1) {
                this.$set(_result.data[idx], "me");
                pushData.push(_result.data[idx]);
              }
            }
          });
          if (pushData && pushData.length > 0) {
            this.$_.forEach(pushData, (item) => {
              this.useGasItems.push(item);
              columns.splice(1, 0, {
                // 가스 헤더 적용 로직 추가 필요
                name: item.sopGasId + "_p",
                field: item.sopGasId + "_p",
                label: item.gasName,
                align: "center",
                sortable: false,
                child: [
                  {
                    name: item.sopGasId,
                    field: item.sopGasId,
                    label: item.safetyStandards,
                    align: "center",
                    type: "text",
                    sortable: false,
                    style: "width:" + 50 / pushData.length + "%",
                  },
                ],
              });
            });
          }
        } else {
          let useYList = this.$_.filter(_result.data, (item) => {
            return (
              item.useFlag === "Y" &&
              this.$_.findIndex(item.workTypes, {
                sopWorkTypeCd: "SWT0000005",
              }) > -1
            );
          });
          this.$_.forEach(useYList, (gas) => {
            this.useGasItems.push(gas);
            columns.splice(1, 0, {
              // 가스 헤더 적용 로직 추가 필요
              name: gas.sopGasId + "_p",
              field: gas.sopGasId + "_p",
              label: gas.gasName,
              align: "center",
              sortable: false,
              child: [
                {
                  name: gas.sopGasId,
                  field: gas.sopGasId,
                  label: gas.safetyStandards,
                  align: "center",
                  type: "text",
                  sortable: false,
                  style: "width:" + 50 / useYList.length + "%",
                },
              ],
            });
          });
        }

        this.grid2.columns = columns;
      });
    },
    addGas() {
      let pushData = {
        sopGasCheckId: uid(), // 가스농도측정번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
        supplementWorkTypeCd: "", // 보충작업구분
        checkTime: "", // 점검시간
        gasCheckMachine: "", // 점검기기명
        gasCheckUserName: "",
        gasCheckUserId: "", // 점검자
        gasConfirmUserName: "",
        gasConfirmUserId: "", // 확인자(입회자)
        regUserId: this.$store.getters.user.userId, // 등록자 ID
        chgUserId: "", // 수정자 ID
        editFlag: "C",
      };
      this.$_.forEach(this.useGasItems, (gas) => {
        this.$set(pushData, gas.sopGasId, "0");
      });

      this.workPermit.gases.push(pushData);
    },
    removeGas() {
      let selectData = this.$refs["gasTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSG0000103", // 제외할 행을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteGasChecks)
          this.workPermit.deleteGasChecks = [];
        if (!this.workPermit.deleteGasCheckVals)
          this.workPermit.deleteGasCheckVals = [];
        this.$_.forEach(selectData, (item) => {
          if (
            this.$_.findIndex(this.workPermit.deleteGasChecks, {
              sopGasCheckId: item.sopGasCheckId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.workPermit.deleteGasChecks.push(item);
            this.$_.forEach(this.useGasItems, (gas) => {
              this.workPermit.deleteGasCheckVals.push({
                sopGasCheckId: item.sopGasCheckId,
                sopGasId: gas.sopGasId,
              });
            });
          }
          this.workPermit.gases = this.$_.reject(this.workPermit.gases, item);
        });
        this.$refs["gasTable"].$refs["compo-table"].clearSelection();
      }
    },
    vendorChange(vendorCd, beforeVendorCd) {
      if (this.workPermit.workers && this.workPermit.workers.length > 0) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          // 확인
          message: "MSG0000115",
          // 해당 작업업체별로 지정된 작업자 정보들이 제외됩니다. 진행하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            if (!this.workPermit.deleteWorkers) {
              this.workPermit.deleteWorkers = [];
            }
            this.$_.forEach(
              this.$_.filter(this.workPermit.workers, {
                vendorCd: beforeVendorCd,
              }),
              (item) => {
                if (
                  this.$_.findIndex(this.workPermit.deleteWorkers, {
                    sopWorkerId: item.sopWorkerId,
                  }) === -1
                ) {
                  this.workPermit.deleteWorkers.push(item);
                }
              },
            );
            this.workPermit.workers = this.$_.reject(this.workPermit.workers, {
              vendorCd: beforeVendorCd,
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
            this.$set(this.workPermit, "vendorCd", beforeVendorCd);
          },
        });
      }
    },
    contentsField(props, col) {
      /**
       * 안전조치사항 항목에서 항목 입력 타입이 '테이블_점검자' 인 경우 테이블에 표시
       * 단, 예전에 '테이블_점검자'였으며 그럼으로 인해 데이터가 저장이 된적이 있는 경우 컴포넌트 표시
       */
      let returnVal = true;
      if (col.name === "confirmUserName") {
        returnVal =
          props.row["sopCheckItemKindCd"] === "SCIK000005" ||
          Boolean(props.row["confirmUserName"]);
      }
      return returnVal;
    },
    // tableDataChange(props, col) {
    //   if (col.name === 'necessaryFlag' && props.row[col.name] !== 'Y') {
    //     this.$set(props.row, 'confirmFlag', 'N');
    //   }
    // },
    setLocationInfo(location, flag) {
      if (location) {
        this.workPermit.maintenanceDeptDrivingManagerId = location.deptLeaderId;
        this.workPermit.maintenanceDeptCheckUserId = location.deptLeaderId;
      } else {
        this.workPermit.maintenanceDeptDrivingManagerId = null;
        this.workPermit.maintenanceDeptCheckUserId = null;
      }
      if (flag === "ADD") {
        /**
         * 추가한 경우
         * locations은 1개
         */
        if (
          this.$_.findIndex(this.workPermit.locationInfos, {
            mdmLocationId: location.mdmLocationId,
          }) === -1 &&
          Boolean(location.sopMapLocationId)
        ) {
          this.$set(this.workPermit, "locationInfos", [
            {
              sopMapResultId: uid(),
              sopWorkPermitId: this.workPermit.sopWorkPermitId,
              mdmLocationId: location.mdmLocationId,
              locationName: location.locationName,
              sopMapId: location.sopMapId,
              locationXcoordinate: location.x,
              locationYcoordinate: location.y,
              locationWidth: location.w,
              locationHeight: location.h,
              ratio: location.ratio,
              editFlag: "C",
              regUserId: this.$store.getters.user.userId,
            },
          ]);
        }

        if (location.mdmLocationId === "ETC") {
          this.$set(this.workPermit, "locationInfos", []);
        }
      } else if (flag === "DELETE") {
        /**
         * 삭제한 경우
         * locations이 없을 수 있음
         */
        // let deleteDatas = [];
        // if (this.$_.findIndex(this.workPermit.locationInfos, { mdmLocationId: location.mdmLocationId }) === -1) {
        //   deleteDatas.push(location)
        // }
        // if (deleteDatas && deleteDatas.length > 0) {
        //   this.$_.forEach(deleteDatas, deleteData => {
        //     this.workPermit.locationInfos = this.$_.reject(this.workPermit.locationInfos, deleteData)
        //   })
        // }
        if (
          this.workPermit.locationInfos &&
          this.workPermit.locationInfos.length > 0
        ) {
          this.$set(this.workPermit, "locationInfos", []);
        }
      }

      // if (!this.isOld) {
      if (
        this.workPermit.locationInfos &&
        this.workPermit.locationInfos.length > 0
      ) {
        this.$set(this.workPermit, "locationMarkFlag", "N");
      } else {
        this.$set(this.workPermit, "locationMarkFlag", "Y");
      }
      // }

      // 위치 직접 표시 X
      if (this.workPermit.locationMarkFlag === "N") {
        let resultTypes = [{ sopWorkTypeCd: this.workPermit.permitTypeCd }];
        if (this.workPermit.supWorks && this.workPermit.supWorks.length > 0) {
          this.$_.forEach(this.workPermit.supWorks, (sup) => {
            resultTypes.push({
              sopWorkTypeCd: sup.supplementWorkTypeCd,
            });
          });
        }
        /**
         * 작업장소 정보를 그대로 넣는 경우 이전에 있었던 정보들은
         * deleteMaps에 넣어줘야 새롭게 데이터가 들어가게 됨
         */
        if (this.workPermit.maps && this.workPermit.maps.length > 0) {
          this.$_.forEach(this.workPermit.maps, (map) => {
            if (this.$_.findIndex(this.workPermit.deleteMaps, map) === -1) {
              this.workPermit.deleteMaps.push(map);
            }
          });
        }
        this.$set(
          this.workPermit,
          "maps",
          this.$_.map(this.workPermit.locationInfos, (item) => {
            return this.$_.extend(item, {
              resultTypes: resultTypes,
              editFlag: "C",
            });
          }),
        );
      } else {
        this.$set(this.workPermit, "maps", []);
      }
    },
    getUserInfo(_userId, num) {
      if (num === 1) return this.$_.find(this.$store.state.systemInfo.users, { userId: _userId }).userName
      else return this.$_.find(this.$store.state.systemInfo.users, { userId: _userId }).deptName
    },
  },
};
</script>
<style lang="sass">
.gas-item
  padding-top:18px !important
  .q-field__inner
    padding-bottom: 0px !important
  .customText
    padding-bottom: 0px !important
.gas-card-title
  font-size: 15px
  font-weight: 800
.trans 
  margin: -20px 0 10px 10px !important
  font-size: 14px
</style>
